class Falecom {

    buttons = false
    header = false
    target = false
    closeButton = false
    handleOut = null

    constructor() {

        this.buttons = document.querySelectorAll('button.fale-conosco,a[href="#contato"]')
        this.target = document.querySelector('.floater-destaques')
        this.content = document.querySelector('.floater-destaques > .content')
        this.header = document.querySelector('#masthead')

        if (this.target && this.buttons.length) {

            this.handleOut = this.clickOut.bind(this)

            for (const button of this.buttons) {

                button.addEventListener('click', (event) => {

                    event.preventDefault()
                    event.stopPropagation()

                    if (this.target.classList.contains('opened')) {
                        this.close()
                    }
                    else {
                        this.open()
                    }

                })

            }

            // Close button
            this.closeButton = this.target.querySelector('button.close')
            this.closeButton.addEventListener('click', (event) => {
                event.preventDefault()
                this.close()
            })

            // Bind finished
            const form = document.querySelector('#contact')
            form.addEventListener('finished', () => {
                this.close()
            })

        }

    }

    clickOut(event) {
        if (!this.content.contains(event.target)) {
            this.close()
        }
    }

    open() {

        this.target.classList.add('opened')
        window.addEventListener('click', this.handleOut)

        // const button = document.querySelector('button.fale-conosco')
        // button.addEventListener('click', (event) => {
        // 	event.preventDefault()
        // 	this.close()
        // })

        if (this.header.classList.contains('sticky')) {
            this.header.classList.remove('to-down')
            this.header.classList.add('to-up')
        }

        //if( window.innerHeight === this.target.offsetHeight ){
        Piki.lockScroll()
        //}

    }

    close() {

        this.target.classList.remove('opened')
        window.removeEventListener('click', this.handleOut)
        Piki.unlockScroll()

        // const button = document.querySelector('button.fale-conosco')
        // button.addEventListener('click', (event) => {
        // 	event.preventDefault()
        // 	this.open()
        // })

    }

}

window.addEventListener('DOMContentLoaded', () => {
    new Falecom()
});